import React from 'react';
import {Link} from "react-router-dom";


export function SalesTerms() {

    return (
        <div className={"d-flex justify-content-center"}>
            <div className={"container w-75 p-5 fs-5"}>
                <h1>Salgsbetingelser for Karakterboost AS</h1>
                <h2 className={"fw-bold"}>1. Om avtalen</h2>

                <div className={"my-3"}>
                    <h3>1.1 Partene</h3>
                    <p>
                        Denne avtalen gjelder mellom Karakterboost AS og elever som går på
                        videregående skole, eller mellom Karakterboost AS og elever som tar
                        opp fag som privatist.
                    </p>
                </div>

                <div className={"my-3 "}>
                    <h3>1.2 Hva avtalen gjelder</h3>
                    <p>
                        Karakterboost sitt kursopplegg består av notater, oppgaver med
                        løsningsforslag, korte videoer, labhefter samt kunstig intelligens.
                    </p>
                    <ul>
                        <li>
                            Med notater menes en digital lærebok som er skreddersydd
                            etter læreplanen i det aktuelle faget.
                        </li>
                        <li>
                            Med labhefte menes en detaljert gjennomgang av relevante
                            forsøk som er et krav i naturfagene hvor formålet er å knytte
                            teori opp mot praksis.
                        </li>
                        <li>
                            Kunstig intelligens i regi av Karakterboost gir eleven umiddelbar
                            tilbakemelding på oppgaver som eleven løser, svar på spørsmål
                            som er relatert til pensum og gir en evaluering av elevens
                            progresjon i kurset.

                        </li>
                    </ul>
                </div>

                <div className={"my-3"}>
                    <h3>1.3 Avtaleinngåelse</h3>
                    <p>
                        Ved å kjøpe tilgang til kurs i aktuelt fag, og huke av for at du
                        godkjenner avtalevilkårene, har du akseptert vilkårene i avtalen.
                    </p>

                    <p>
                        Påmeldingsbekreftelsen sammen med godkjenningen av vilkårene
                        utgjør elevens avtale med Karakterboost AS.
                    </p>

                    <p>
                        Ved kjøp av kurs får eleven tilsendt et salgsbillag på den e –
                        postadressen som er tilknyttet eleven sin konto hos Vipps Mobilepay
                        AS. Salgsbillaget inneholder følgende informasjon;
                    </p>

                    <ul>
                        <li>
                            Hva ble kjøpt
                        </li>
                        <li>
                            Når ble kjøpet gjort
                        </li>
                        <li>
                            Prisen
                        </li>
                        <li>
                            Hvilken betalingsmetode som ble brukt
                        </li>
                    </ul>

                </div>

                <div className={"my-3"}>
                    <h3>1.4 Pris</h3>
                    <p>
                        Prisen på kurs i aktuelt fag varierer etter hvilke deler av
                        kursmaterialet som eleven ønsker tilgang til, og hvor lenge eleven
                        ønsker tilgang.
                    </p>

                    <p>
                        Kursmateriale selges som månedsabonnement (lisens). Dette
                        abonnementet blir fornyet hver måned inntil eleven sier opp
                        tjenesten; altså foreligger det ingen bindingstid for å tegne et
                        abonnement. Dersom eleven ønsker å avslutte sitt abonnement må
                        eleven kontakt oss på <span className={"text-primary"}>mathias.junker@karakterboost.no</span>
                    </p>
                </div>

                <div className={"my-3"}>
                    <h3>1.5 Betaling</h3>
                    <p>
                        Betalingen skjer gjennom Vipps Mobilepay AS. Når eleven kjøper
                        tilgang vil eleven få betalingsbekreftelse fra Vipps.
                    </p>
                </div>

                <div className={"my-3"}>
                    <h3>1.6 Levering</h3>
                    <p>
                        Levering skjer når eleven får betalingsbekreftelse fra Vipps. Da vil
                        eleven få tilgang til hele kursmaterialet. Tilgangen til kursmaterialet
                        korresponderer til abonnementsperioden.
                    </p>
                    <p>
                        Eleven får tilgang til kursmaterialet ved å logge seg inn med e –
                        postadressen tilknyttet Vipps samt lager et personlig passord. Når
                        abonnementsperioden utløper mister eleven tilgang til
                        kursmaterialet.
                    </p>
                    <p>
                        Ettersom kursmaterialet leveres umiddelbart ved kjøp bortfaller
                        retten til å angre kjøpet jf. angrerettloven §22 bokstav c og bokstav n.
                    </p>
                    <p>
                        Av den grunn må derfor eleven vedkjenne seg at retten til å angre
                        kjøpet bortfaller. Dette må eleven gi uttrykkelige forhåndssamtykke
                        om ved å huke av i en boks. Avhukingen, som innebærer at eleven er
                        innforstått med at retten til å angre kjøpet går tapt, må være i orden
                        før kjøpet lar seg gjennomføre.
                    </p>
                </div>

                <h2 className={"fw-bold"}>2. Øvrige vilkår</h2>

                <div className={"my-3"}>
                    <h3>2.1 Opphavsrett</h3>
                    <p>
                        Abonnementskursene er beskyttet av opphavsrett og kan under ingen
                        omstendighet kopieres, distribueres eller på annen måte gjøres kjent
                        for tredjeparter eller brukes i kommersielle sammenhenger.
                    </p>
                    <p>
                        Kurset kan kun brukes av elever som har tegnet abonnement. Det er
                        derfor forbudt å dele passord til elevens personlige bruker med
                        andre.
                    </p>
                </div>

                <div className={"my-3"}>
                    <h3>2.2 Elevens plikter</h3>
                    <p>
                        Når eleven kjøper tilgang til kurs er eleven selv ansvarlig for å velge
                        riktig kombinasjon av fag som for å oppnå ønsket kompetanse.
                    </p>
                    <p>
                        Som privatist er du selv ansvarlig for å;
                    </p>

                    <ul>
                        <li>
                            2.2.1 Melde deg opp til riktig eksamen
                        </li>
                        <li>
                            2.2.2 Kontrollere at eksamenene dine ikke faller på samme
                            tidspunkt. Kun aktuelt dersom eleven velger å avholde eksamen
                            i ulike fylkeskommuner samme semester.
                        </li>
                        <li>
                            2.2.3 Oppdatere vitnemålet slik at eksamenskarakteren blir
                            inkludert.
                        </li>
                    </ul>

                    <p>
                        Når du er elev hos oss skal du opptre hensynsfullt, f. eks når du stiller
                        spørsmål til vår AI – lærer. Bruk av skjellsord, sjikanering eller annen
                        utilbørlig atferd tolereres ikke i elevens kommunikasjon. Brudd på
                        ordensreglene kan føre til kansellering av avtalen.
                    </p>
                </div>

                <div className={"my-3"}>
                    <h3>2.4  Elevens rettigheter vedrørende mangler og reklamasjon</h3>
                    <p>
                        Karakterboost leverer en digital læringstjeneste. Av den grunn vil ikke
                        bestemmelsene i forbrukerkjøpsloven a’ 21.06.2002 gjelde jf. §1. Dersom eleven eller privatisten påberoper seg en mangel ved
                        tjenesten ber vi innstendig om å kontakte oss innen rimelig tid på
                        mathias.junker@karakterboost.no etter at mangelen ble oppdaget.
                    </p>
                    <p>
                        Detaljert informasjon om behandling og lagring av personopplysninger finner du i vår <Link to={"/info/privacy"}>personvernerklæring</Link>.
                    </p>
                </div>

                <div className={"my-3"}>
                    <h3>2.5 Konfliktløsning</h3>
                    <p>
                        Klager rettes til selger innen rimelig tid. Partene skal forsøke å løse
                        eventuelle tvister i minnelighet. Dersom dette ikke lykkes, kan
                        kjøperen ta kontakt med Forbrukertilsynet for mekling.
                        Forbrukertilsynet er tilgjengelig på telefon 23 400 600 eller <Link to={"www.forbrukertilsynet.no"}>forbrukertilsynet.no</Link>.
                    </p>
                    <p>
                        Europa-Kommisjonens klageportal kan også brukes hvis du ønsker å
                        inngi en klage. Det er særlig relevant, hvis du er forbruker bosatt i et
                        annet EU-land. Klagen inngis her: <Link to={"https://ec.europa.eu/odr"}>https://ec.europa.eu/odr</Link>
                    </p>

                </div>

                <div className={"my-3"}>
                    <h3>2.6 Personvern</h3>
                    <p>
                        Karakterboost vil samle inn og lagre personlig informasjon om elevens
                        navn, adresse, telefonnummer, e – postadresse og
                        betalingsinformasjon for å gi eleven tilgang til tjenestene. Spørringer
                        som blir gjort til vår AI – lærer vil også lagres.
                    </p>
                    <p>
                        Detaljert informasjon om behandling og lagring av personopplysninger finner du i vår <Link to={"/info/privacy"}>personvernerklæring</Link>.
                    </p>
                </div>

            </div>
        </div>
    )

}
